import { render, staticRenderFns } from "./trash.vue?vue&type=template&id=dd20312e&scoped=true&"
import script from "./trash.vue?vue&type=script&lang=ts&"
export * from "./trash.vue?vue&type=script&lang=ts&"
import style0 from "./trash.vue?vue&type=style&index=0&id=dd20312e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd20312e",
  null
  
)

export default component.exports